const ProjectDescription = (props: any) => {
  return (
    <div className="bg-white border border-gray-700 flex flex-col p-4 gap-4">
      <h2 className="border-b border-gray-300 text-lg font-normal ">
        Project Description
      </h2>
      <p className="text-sm text-justify">{props.desc}</p>
      <hr />
      <button
        onClick={() => {
          window.scrollTo(0, 0);
        }}
        className="px-3 py-2 bg-primary w-fit text-white capitalize"
      >
        Register to get pricing for {props.title}
      </button>
    </div>
  );
};

export default ProjectDescription;
